import Message from 'shared_components/message';
import { axiosLabAPI } from '../axios';
import { API_GET_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchExamAndPanelList() {
	let exams = [];
	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `settings/examrequestallpanelsandexamrequest`,
		});
		const { data } = await response;

		exams = data.RECORDS;
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		showMessage(status);
	}

	return exams;
}

export async function fetchSectionExams(id) {
	let exams = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `settings/examrequestpersection`,
			params: { p_ids: id },
		});

		const { data } = response;

		exams = data.RECORDS;
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		showMessage(status);
	}

	return exams;
}
